import { useNavigate } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  IconButton,
  Stack,
  Avatar,
  Fade,
  Grid,
  Tabs,
  Tab
} from '@mui/material';
import {
  Close as CloseIcon,
  CalendarMonth as CalendarIcon,
  Business as BusinessIcon,
  Description as DescriptionIcon,
  NoteAlt as NoteIcon,
  CheckCircle as CheckIcon,
  AccessTime as TimeIcon
} from '@mui/icons-material';

import { Assignment } from '@mui/icons-material';
import { useEffect, useState } from 'react';

const InfoItem = ({ icon: Icon, label, value, highlight = false, compact = false }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1.5,
      p: compact ? 1.5 : 2,
      //borderRadius: 2,
      //transition: 'all 0.2s ease',
      // bgcolor: highlight ? '#f0f4ff' : 'transparent',
      // border: highlight ? '1px solid #121528' : '1px solid transparent',
      // '&:hover': {
      //   bgcolor: '#f8f9fa',
      // }
      bgcolor: '#f8f9fa',
      borderRadius: 2,
      border: '1px solid #e0e0e0'
    }}
  >
    <Avatar
      sx={{
        bgcolor: highlight ? '#121528' : '#e9ecef',
        color: highlight ? 'white' : '#121528',
        width: compact ? 36 : 40,
        height: compact ? 36 : 40
      }}
    >
      <Icon sx={{ fontSize: compact ? 18 : 20 }} />
    </Avatar>
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Typography
        variant="caption"
        sx={{
          color: '#6c757d',
          fontWeight: 600,
          textTransform: 'uppercase',
          fontSize: '0.65rem',
          letterSpacing: '0.5px'
        }}
      >
        {label}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          mt: 0.2,
          color: '#121528',
          fontWeight: highlight ? 600 : 500,
          fontSize: compact ? '0.9rem' : (highlight ? '1rem' : '0.92rem'),
          wordBreak: 'break-word',
          lineHeight: 1.3
        }}
      >
        {value || 'No especificado'}
      </Typography>
    </Box>
  </Box>
);

const CitaConfirmadaDialog = ({
  open,
  handleClose,
  cita,
  isSuccess,
}) => {
  
  const navigate = useNavigate();
  const [tabCodigo, setTabCodigo] = useState('qr');
  useEffect(() => {
      if (open) setTabCodigo('qr');
  }, [open, setTabCodigo]);
  
  //const isExpediente = cita?.cit_servicio_descripcion?.toLowerCase().includes('expediente');

  // if (!open) return null;
  
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      TransitionComponent={Fade}
      PaperProps={{
        sx: {
          borderRadius: 4,
          boxShadow: '0 20px 60px rgba(18, 21, 40, 0.15)',
          overflow: 'hidden'
        }
      }}
    >
      {/* Header compacto */}
      <Box
        sx={{
          bgcolor: '#121528',
          color: 'white',
          p: 3,
          position: 'relative',
          background: 'linear-gradient(135deg, #121528 0%, #1e2442 50%, #121528 100%)'
        }}
      >
        <IconButton
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: 'white',
            bgcolor: 'rgba(255, 255, 255, 0.1)',
            '&:hover': {
              bgcolor: 'rgba(255, 255, 255, 0.2)'
            }
          }}
        >
          <CloseIcon />
        </IconButton>

        <Box sx={{ textAlign: 'center' }}>
          <Box
            sx={{
              display: 'inline-flex',
              bgcolor: 'rgba(255, 255, 255, 0.15)',
              p: 1.5,
              borderRadius: '50%',
              mb: 1.5
            }}
          >
            <CheckIcon sx={{ fontSize: 32, color: 'white' }} />
          </Box>
          <Typography variant="h5" sx={{ fontWeight: 700, mb: 0.5 }}>
            Cita agendada
          </Typography>

          <Typography variant="body2" sx={{ opacity: 0.85, fontSize: '0.875rem' }}>
            {isSuccess 
              ? 'Tu cita fue creada correctamente' 
              : 'Revisa los detalles antes de confirmar'}
          </Typography>
        </Box>
      </Box>

      {/* Contenido optimizado */}
      <DialogContent sx={{ p: 3, bgcolor: 'white' }}>
        <Stack spacing={1}>
          {/* Fecha y Hora en la misma fila - Solo iconos y texto */}
          <Box
            sx={{
              p: 2,
              bgcolor: '#f8f9fa',
              borderRadius: 2,
              border: '1px solid #e0e0e0'
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={7}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <CalendarIcon sx={{ fontSize: 20, color: '#121528' }} />
                  <Box>
                    <Typography
                      variant="caption"
                      sx={{
                        color: '#6c757d',
                        fontWeight: 600,
                        textTransform: 'uppercase',
                        fontSize: '0.65rem',
                        letterSpacing: '0.5px',
                        display: 'block'
                      }}
                    >
                      Fecha
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        color: '#121528',
                        fontWeight: 600,
                        fontSize: '0.95rem',
                        lineHeight: 1.3
                      }}
                    >
                      {cita?.inicio ? new Date(cita.inicio).toLocaleDateString('es-MX', {day: '2-digit', month:'2-digit', year:'numeric'}) : 'No especificada'}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={5}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <TimeIcon sx={{ fontSize: 20, color: '#121528' }} />
                  <Box>
                    <Typography
                      variant="caption"
                      sx={{
                        color: '#6c757d',
                        fontWeight: 600,
                        textTransform: 'uppercase',
                        fontSize: '0.65rem',
                        letterSpacing: '0.5px',
                        display: 'block'
                      }}
                    >
                      Hora
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        color: '#121528',
                        fontWeight: 600,
                        fontSize: '0.95rem',
                        lineHeight: 1.3
                      }}
                    >
                      {cita?.inicio 
                        ? new Date(cita.inicio).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit', hour12: false })
                        : '--:--'
                      }
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>

          {/* Resto de la información */}
          
          <InfoItem
            icon={BusinessIcon}
            label="Unidad"
            value={cita?.oficina_descripcion || 'No especificada'}
            compact={true}
          />

          <InfoItem
            icon={Assignment}
            label="Tipo de trámite"
            value={cita?.cit_servicio_descripcion || 'No especificado'}
            compact={true}
          />

          <InfoItem
            icon={cita?.cit_servicio_descripcion?.toLowerCase().includes('expediente')
              ? DescriptionIcon
              : NoteIcon
            }
            label={cita?.cit_servicio_descripcion?.toLowerCase().includes('expediente')
              ? 'Expediente'
              : 'Notas'
            }
            value={cita?.notas || 'Sin información adicional'}
            compact={true}
          />
          
        </Stack>
        
     

        {/* Solo tabs si tiene ambos */}
        {cita?.codigo_acceso_url && cita?.codigo_barras_url ? (
          <Box sx={{ mt: 2.5 }}>
            <Tabs
              value={tabCodigo}
              onChange={(_, v) => setTabCodigo(v)}
              centered
              sx={{
                mb: 2,
                '& .MuiTab-root': { fontWeight: 600, fontSize: '0.75rem' },
                '& .Mui-selected': { color: '#000' },
                '& .MuiTabs-indicator': { backgroundColor: '#000' },
              }}
            >
              <Tab label="Código de acceso" value="qr" />
              <Tab label="Código de asistencia" value="barras" />
            </Tabs>

            {tabCodigo === 'qr' && (
              <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 2, border: '1px solid #dee2e6', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                <img alt="qr" src={cita.codigo_acceso_url} width={200} style={{ borderRadius: 8, display: 'block' }} />
                <Typography variant="caption" display="block" mt={1.5} sx={{ color: '#121528', fontWeight: 600, fontSize: '0.75rem', letterSpacing: '0.5px' }}>
                  {cita?.id}
                </Typography>
              </Box>
            )}

            {tabCodigo === 'barras' && (
              <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 2, border: '1px solid #dee2e6', textAlign: 'center' }}>
               
                <img alt="barras" src={cita.codigo_barras_url} width={200} style={{ borderRadius: 8 }} />
              </Box>
            )}
          </Box>

        ) : cita?.codigo_acceso_url ? (
          // Solo QR — sin tabs
          <Box sx={{ mt: 2.5, p: 2, bgcolor: '#f8f9fa', borderRadius: 2, border: '1px solid #dee2e6', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
            <Typography variant="caption" sx={{ color: '#6c757d', fontWeight: 600, mb: 1, textTransform: 'uppercase', fontSize: '0.65rem', display: 'block' }}>
              Código de acceso
            </Typography>
            <img alt="qr" src={cita.codigo_acceso_url} width={200} style={{ borderRadius: 8, display: 'block' }} />
            <Typography variant="caption" display="block" mt={1.5} sx={{ color: '#121528', fontWeight: 600, fontSize: '0.75rem', letterSpacing: '0.5px' }}>
              {cita?.id}
            </Typography>
          </Box>

        ) : cita?.codigo_barras_url ? (
          // Solo barras — sin tabs
          <Box sx={{ mt: 2.5, p: 2, bgcolor: '#f8f9fa', borderRadius: 2, border: '1px solid #dee2e6', textAlign: 'center' }}>
            <Typography variant="caption" sx={{ color: '#6c757d', fontWeight: 600, textTransform: 'uppercase', fontSize: '0.65rem', display: 'block', mb: 1.5 }}>
              Código de asistencia
            </Typography>
            <img alt="barras" src={cita.codigo_barras_url} width={200} style={{ borderRadius: 8 }} />
          </Box>

        ) : null}


        {/* Nota informativa compacta */}
        <Box
          sx={{
            mt: 2,
            p: 1.5,
            bgcolor: '#fff9e6',
            borderRadius: 2,
            borderLeft: '3px solid #ffc107',
            display: 'flex',
            gap: 1,
            alignItems: 'center'
          }}
        >
          <Typography variant="body2" sx={{ fontSize: '1rem' }}>
            💡
          </Typography>
          <Typography variant="body2" sx={{ color: '#856404', fontSize: '0.85rem' }}>
            Llega 15 minutos antes de la hora programada
          </Typography>
        </Box>
      </DialogContent>

      {/* Acciones */}
      <DialogActions
        sx={{
          p: 2.5,
          bgcolor: '#f8f9fa',
          gap: 1.5,
          borderTop: '1px solid #e9ecef'
        }}
      >
        <Button
          onClick={handleClose}
          fullWidth
          sx={{
            borderColor: '#dee2e6',
            color: '#495057',
            fontWeight: 600,
            py: 1.2,         
          }}
        >
          Cancelar
        </Button>

        <Button
          onClick={() => navigate('/citas')}
          variant="contained"
          fullWidth
          sx={{
            bgcolor: '#121528',
            fontWeight: 600,
            py: 1.2,   
          }}
        >
          Ver mis citas
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CitaConfirmadaDialog;
